import Phaser from "phaser";

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: "BootScene" });
  }

  preload(): void {
    // Generate placeholder textures using graphics
    this.createPlaceholderAssets();
  }

  create(): void {
    this.scene.start("TitleScene");
  }

  private createPlaceholderAssets(): void {
    // Create a simple button texture
    const btnGraphics = this.add.graphics();
    btnGraphics.fillStyle(0x4a90d9, 1);
    btnGraphics.fillRoundedRect(0, 0, 200, 60, 12);
    btnGraphics.generateTexture("btn_blue", 200, 60);
    btnGraphics.destroy();

    // Create a red button texture
    const btnRedGraphics = this.add.graphics();
    btnRedGraphics.fillStyle(0xe74c3c, 1);
    btnRedGraphics.fillRoundedRect(0, 0, 200, 60, 12);
    btnRedGraphics.generateTexture("btn_red", 200, 60);
    btnRedGraphics.destroy();

    // Create share button texture (X/Twitter blue)
    const btnShareGraphics = this.add.graphics();
    btnShareGraphics.fillStyle(0x1da1f2, 1);
    btnShareGraphics.fillRoundedRect(0, 0, 200, 60, 12);
    btnShareGraphics.generateTexture("btn_share", 200, 60);
    btnShareGraphics.destroy();
  }
}
